
// import './login.css';

// import Logo from '../img/logo.png'; // นำเข้าภาพพื้นหลัง
// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import {  API_ENDPOINT,API_ENDPOINT_USER } from '../auth/config';
// import Navbar from "../navbarv2/navbar";
// import Footer from "../navbarv2/footer";
// import Swal from 'sweetalert2';
// function RegisterPage() {

//   const [inputs, setInputs] = useState({});
//   const [errorMessage, setErrorMessage] = useState("");
//   const [showErrorMessage, setShowErrorMessage] = useState(false);


//   const handleChange = (event) => {
//     const name = event.target.name;
//     const value = event.target.value;
//     setInputs(values => ({ ...values, [name]: value }))
//   }



//   const handleSubmit = (event) => {
//     event.preventDefault();

//     const formdata = new FormData();
//     formdata.append("email", inputs.email);
//     formdata.append("password", inputs.password);
//     formdata.append("name", inputs.name);

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };
//     for (let [key, value] of formdata.entries()) {
//       console.log(`${key}: ${value}`);
//   }
//     fetch(`${API_ENDPOINT_USER}/e-member/public/api/register`, requestOptions)
//       .then((response) => response.json())
//       .then((result) => {
//         console.log(result)
//         if (result.status === 'true') {
//           // setErrorMessage("Invalid Credentials");
//           // setShowErrorMessage(true);
//           Swal.fire({
//               icon: 'success',
//               title: 'ลงทะเบียนสำเร็จ!',
//               text: 'คุณได้ลงทะเบียนสำเร็จแล้ว',
//               confirmButtonText: 'ตกลง'
//           }).then(() => {
//             window.location.href = '/emember/login';
             
//           });
//       } else {
//         setShowErrorMessage(true);
//           // จัดการกับกรณีที่ไม่สำเร็จ
//           Swal.fire({
//               icon: 'error',
//               title: 'เกิดข้อผิดพลาด!',
//               text: result.error,
//               confirmButtonText: 'ตกลง'
//           });
//       }
//         // if (result.message === "User Created ") {
//         //   // console.log(result);
//         //   setErrorMessage("Invalid Credentials");
//         //   setShowErrorMessage(true);
//         // } else {
//         //   // console.log(result);
//         //   setErrorMessage("User Created successful");
//         //   setShowErrorMessage(true);
//         // }
//       })
//       .catch((error) => console.error(error));

//     // alert(inputs);
//   }


//   return (
//     <>
//       <Navbar></Navbar>
//       <section className="background-radial-gradient overflow-hidden">
//         <div className="container px-4 py-5 px-md-5 text-center text-lg-start my-5">
//           <div className="row gx-lg-5 align-items-center mb-5">
//             <div className="col-lg-6 mb-5 mb-lg-0" style={{ zIndex: 10 }}>
//               <img src={Logo} alt="Logo" className="mb-4" style={{ maxWidth: '150px' }} />
//               <h1 className="my-5 display-5 fw-bold ls-tight" style={{ color: 'hsl(218, 81%, 95%)' }}>
//                 Welcome Sing up <br />
//                 <span style={{ color: 'hsl(218, 81%, 75%)' }}>To Zoo e-Ticket</span>
//               </h1>
//               <p className="mb-4 opacity-70" style={{ color: 'hsl(218, 81%, 85%)' }}>
//                 องค์การสวนสัตว์แห่งประเทศไทย ในพระบรมราชูปถัมภ์
//                 The Zoological Park Organization under The Royal Patronage of H.M. The King
//                 เลขที่ 327 ถนนสุโชทัย แขวงดุสิต เขตดุสิต กรุงเทพมหานคร 10300
//               </p>
//             </div>

//             <div className="col-lg-6 mb-5 mb-lg-0 position-relative">
//               <div id="radius-shape-1" className="position-absolute rounded-circle shadow-5-strong"></div>
//               <div id="radius-shape-2" className="position-absolute shadow-5-strong"></div>

//               <div className="card bg-glass">

//                 <div className="card-body px-4 py-5 px-md-5">
//                   {/* {showErrorMessage && (
//                     <div className='container'>  <div className={`alert ${errorMessage === "Invalid Credentials" ? "alert-danger" : "alert-success"}`} role="alert">
//                       {errorMessage}
//                     </div></div>

//                   )} */}
//                   <form onSubmit={handleSubmit}>


//                     <div className="form-outline mb-4">
//                       <input type="text" id="name" name='name' className="form-control" onChange={handleChange} />
//                       <label className="form-label">Name</label>
//                     </div>

//                     <div className="form-outline mb-4">
//                       <input type="email" id="email" name='email' className="form-control" onChange={handleChange} />
//                       <label className="form-label">Email address</label>
//                     </div>

//                     <div className="form-outline mb-4">
//                       <input type="password" name="password" id="password" className="form-control" onChange={handleChange} />
//                       <label className="form-label" >Password</label>
//                     </div>


//                     <button type="submit" className="btn btn-primary btn-block mb-4">
//                       สมัครสมาชิก
//                     </button>

//                     <div className="text-center">
//                       มีบัญชีผู้ใช้งานแล้ว?
//                       <Link to="/login" style={{ fontSize: 25, fontWeight: '275', border: 'none', color: '#17612F' }} >เข้าสู่ระบบ!!</Link>
//                     </div>
//                   </form>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <Footer></Footer>

//     </>
//     // <section className="bg-section">

//     //   <div className='py-5' ></div>
//     //   <div className="container py-5  r">
//     //     <div className="container py-5 box-input fadeInDown" style={{  position: 'relative', borderRadius:  '6em' }}>
//     //       <img className=" fadeIn first" style={{ width: '10em', height: '10em', position: 'absolute', top: '-0.2%', left: '50%', transform: 'translate(-50%, -50%)'}} src={Logo} id="icon" alt="User Icon"/>
//     //           <br />
//     //       <div className="container py-3 py-md-3 px-md-5 fadeIn second text-center" id="formContent">

//     //         <div style={{textAlign: 'center', color: '#17612F', fontSize: 35, fontWeight: '400', wordWrap: 'break-word'}}>สมัครสมาชิก</div>
//     //         <div style={{textAlign: 'center', color: '#17612F', fontSize: 25, fontWeight: '275', wordWrap: 'break-word'}}>Zoo E-Ticket</div>
//     //         {showErrorMessage && (
//     //           <div className='container'>  <div className={`alert ${errorMessage === "Invalid Credentials" ? "alert-danger" : "alert-success"}`} role="alert">
//     //             {errorMessage}
//     //           </div></div>

//     //         )}

//     //         <form onSubmit={handleSubmit} className="px-md-5 py-2">
//     //           <div className="row px-md-5 ">
//     //             <div className="input-group mt-3 px-md-4  box-input" style={{borderRadius:  '3em'}}>
//     //                 <input style={{  color: 'black', fontSize: 25 ,fontWeight:'275',border: 'none',backgroundColor:'transparent' }}  type="text" id="name" className="form-control fadeIn third pl-4 pl-md-0 py-3" name="name" placeholder="ชื่อ" value={inputs.name || ""}
//     //             onChange={handleChange}/>   
//     //             </div>
//     //           </div>

//     //           <div className="row px-md-5 ">
//     //             <div className="input-group mt-3 px-md-4  box-input" style={{borderRadius:  '3em'}}>
//     //                 <input style={{  color: 'black', fontSize: 25 ,fontWeight:'275',border: 'none',backgroundColor:'transparent' }}  type="email" id="email" className="form-control fadeIn third pl-4 pl-md-0 py-3" name="email"  placeholder="อีเมล" value={inputs.email || ""}
//     //             onChange={handleChange}/>   
//     //             </div>
//     //           </div>

//     //           <div className="row px-md-5 ">
//     //             <div className="input-group mt-3 px-md-4  box-input" style={{borderRadius:  '3em'}}>
//     //                 <input style={{  color: 'black', fontSize: 25 ,fontWeight:'275',border: 'none',backgroundColor:'transparent' }}  type="password" id="password" className="form-control fadeIn third pl-4 pl-md-0 py-3" name="password"  placeholder="รหัสผ่าน"  value={inputs.password || ""}
//     //             onChange={handleChange}/>   
//     //             </div>
//     //           </div>

//     //           <button  style={{borderRadius: 103, fontSize: 26}} className="btn btn-primary col-12 col-md-5 box-button mt-3 p-1 p-md-2 fadeIn third" type="submit" value="Sing Up">สมัครสมาชิก</button>

//     //         </form>
//     //         <div id="formFooter" className="fadeIn fourth" style={{ fontSize: 25 ,fontWeight:'275',}}>
//     //           มีบัญชีผู้ใช้งานแล้ว?
//     //           <Link  to="/login"  style={{ fontSize: 25 ,fontWeight:'275',border: 'none', color: '#17612F'}} >เข้าสู่ระบบ!!</Link>
//     //         </div>

//     //       </div>
//     //     </div>
//     //   </div>

//     // </section>
//   );
// }

// export default RegisterPage;




import './login.css';
import Logo from '../img/logo.png';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { API_ENDPOINT, API_ENDPOINT_USER } from '../auth/config';
import Navbar from "../navbarv2/navbar";
import Footer from "../navbarv2/footer";
import Swal from 'sweetalert2';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&family=Outfit:wght@300;400;500;600&display=swap');

  .zoo-register-page {
    min-height: 100vh;
    background: #0a1628;
    position: relative;
    overflow: hidden;
  }

  .zoo-register-page::before {
    content: '';
    position: absolute;
    width: 600px;
    height: 600px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(34, 197, 94, 0.1) 0%, transparent 70%);
    top: -150px;
    left: -150px;
    pointer-events: none;
  }

  .zoo-register-page::after {
    content: '';
    position: absolute;
    width: 450px;
    height: 450px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(16, 185, 129, 0.08) 0%, transparent 70%);
    bottom: -100px;
    right: -80px;
    pointer-events: none;
  }

  .zoo-register-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    min-height: calc(100vh - 120px);
    max-width: 1200px;
    margin: 0 auto;
    padding: 60px 40px;
    gap: 80px;
    align-items: center;
  }

  @media (max-width: 900px) {
    .zoo-register-grid {
      grid-template-columns: 1fr;
      padding: 40px 24px;
      gap: 40px;
    }
    .zoo-register-hero { display: none; }
  }

  .zoo-register-hero {
    position: relative;
    z-index: 2;
  }

  .zoo-register-hero img.hero-logo {
    width: 80px;
    margin-bottom: 32px;
    filter: drop-shadow(0 0 20px rgba(34, 197, 94, 0.4));
  }

  .zoo-register-hero h1 {
    font-size: 3.2rem;
    font-weight: 700;
    color: #f1f5f9;
    line-height: 1.15;
    margin-bottom: 12px;
  }

  .zoo-register-hero h1 span {
    color: #22c55e;
  }

  .zoo-register-hero p {
    font-size: 0.875rem;
    color: #64748b;
    line-height: 1.7;
    max-width: 380px;
    margin-top: 20px;
  }

  .hero-features {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 36px;
  }

  .hero-feature-item {
    display: flex;
    align-items: center;
    gap: 12px;
    color: #94a3b8;
    font-size: 0.875rem;
  }

  .hero-feature-icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: rgba(34, 197, 94, 0.1);
    border: 1px solid rgba(34, 197, 94, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.9rem;
    flex-shrink: 0;
  }

  /* CARD */
  .zoo-register-card {
    position: relative;
    z-index: 2;
    background: rgba(15, 23, 42, 0.8);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 24px;
    padding: 48px 44px;
    backdrop-filter: blur(20px);
    box-shadow: 0 32px 80px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.05);
  }

  .card-eyebrow {
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    color: #22c55e;
    margin-bottom: 8px;
  }

  .card-title {
    font-size: 1.9rem;
    color: #f1f5f9;
    font-weight: 700;
    margin-bottom: 8px;
  }

  .card-subtitle {
    font-size: 0.875rem;
    color: #475569;
    margin-bottom: 32px;
  }

  /* STEP INDICATOR */
  .zoo-steps {
    display: flex;
    gap: 8px;
    margin-bottom: 28px;
  }

  .zoo-step {
    height: 4px;
    border-radius: 2px;
    background: rgba(255,255,255,0.08);
    flex: 1;
    transition: background 0.3s;
  }

  .zoo-step.active { background: #22c55e; }

  /* INPUTS */
  .zoo-field {
    margin-bottom: 20px;
  }

  .zoo-field label {
    display: block;
    font-size: 0.8rem;
    font-weight: 500;
    color: #94a3b8;
    margin-bottom: 8px;
    letter-spacing: 0.03em;
  }

  .zoo-field input {
    width: 100%;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 12px;
    padding: 13px 16px;
    color: #f1f5f9;
    font-size: 0.95rem;
    transition: border-color 0.2s, box-shadow 0.2s;
    outline: none;
    box-sizing: border-box;
  }

  .zoo-field input:focus {
    border-color: #22c55e;
    box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.12);
  }

  .zoo-field input::placeholder { color: #475569; }

  /* SUBMIT BUTTON */
  .zoo-btn-primary {
    width: 100%;
    padding: 14px;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    border: none;
    border-radius: 12px;
    color: #fff;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.15s, box-shadow 0.15s;
    box-shadow: 0 4px 20px rgba(34, 197, 94, 0.3);
    margin-top: 8px;
  }

  .zoo-btn-primary:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 28px rgba(34, 197, 94, 0.4);
  }

  .zoo-card-footer {
    text-align: center;
    margin-top: 24px;
    font-size: 0.875rem;
    color: #475569;
  }

  .zoo-card-footer a {
    color: #22c55e;
    text-decoration: none;
    font-weight: 600;
    margin-left: 4px;
  }

  .zoo-card-footer a:hover { text-decoration: underline; }

  .zoo-terms {
    font-size: 0.75rem;
    color: #334155;
    text-align: center;
    margin-top: 16px;
    line-height: 1.5;
  }
`;

function RegisterPage() {
  const [inputs, setInputs] = useState({});

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputs(v => ({ ...v, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const formdata = new FormData();
    formdata.append("email", inputs.email);
    formdata.append("password", inputs.password);
    formdata.append("name", inputs.name);

    fetch(`${API_ENDPOINT_USER}/e-member/public/api/register`, { method: "POST", body: formdata, redirect: "follow" })
      .then(r => r.json())
      .then(result => {
        if (result.status === 'true') {
          Swal.fire({
            icon: 'success',
            title: 'ลงทะเบียนสำเร็จ!',
            text: 'คุณได้ลงทะเบียนสำเร็จแล้ว',
            confirmButtonText: 'ตกลง'
          }).then(() => { window.location.href = '/emember/login'; });
        } else {
          Swal.fire({ icon: 'error', title: 'เกิดข้อผิดพลาด!', text: result.error, confirmButtonText: 'ตกลง' });
        }
      })
      .catch(console.error);
  };

  return (
    <>
      <style>{styles}</style>
      <Navbar />
      <div className="zoo-register-page">
        <div className="zoo-register-grid">

          {/* HERO */}
          <div className="zoo-register-hero">
            <img src={Logo} alt="Zoo Logo" className="hero-logo" />
            <h1>เริ่มต้นกับ<br /><span>Zoo e-Ticket</span></h1>
            <p>
              องค์การสวนสัตว์แห่งประเทศไทย ในพระบรมราชูปถัมภ์<br />
              The Zoological Park Organization under The Royal Patronage of H.M. The King
            </p>
            <div className="hero-features">
              <div className="hero-feature-item">
                <div className="hero-feature-icon">🎫</div>
                <span>ซื้อตั๋วออนไลน์ได้ทุกที่ทุกเวลา</span>
              </div>
              <div className="hero-feature-item">
                <div className="hero-feature-icon">⚡</div>
                <span>เข้าสวนสัตว์ได้รวดเร็ว ไม่ต้องรอต่อคิว</span>
              </div>
    
            </div>
          </div>

          {/* CARD */}
          <div className="zoo-register-card">
            <div className="card-eyebrow">สมัครสมาชิก</div>
            <div className="card-title">สร้างบัญชีใหม่</div>
            <div className="card-subtitle">กรอกข้อมูลเพื่อเริ่มต้นใช้งาน Zoo e-Ticket</div>

            <div className="zoo-steps">
              <div className="zoo-step active"></div>
              <div className="zoo-step active"></div>
              <div className="zoo-step active"></div>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="zoo-field">
                <label htmlFor="name">ชื่อ-นามสกุล</label>
                <input type="text" id="name" name="name" placeholder="สมชาย ใจดี" onChange={handleChange} required />
              </div>

              <div className="zoo-field">
                <label htmlFor="email">อีเมล</label>
                <input type="email" id="email" name="email" placeholder="your@email.com" onChange={handleChange} required />
              </div>

              <div className="zoo-field">
                <label htmlFor="password">รหัสผ่าน</label>
                <input type="password" id="password" name="password" placeholder="อย่างน้อย 8 ตัวอักษร" onChange={handleChange} required />
              </div>

              <button type="submit" className="zoo-btn-primary">สมัครสมาชิก</button>
            </form>

            <div className="zoo-terms">
              การสมัครสมาชิกถือว่าคุณยอมรับ<br />
              เงื่อนไขการใช้งานและนโยบายความเป็นส่วนตัว
            </div>

            <div className="zoo-card-footer">
              มีบัญชีอยู่แล้ว?
              <Link to="/login">เข้าสู่ระบบ</Link>
            </div>
          </div>

        </div>
      </div>
      <Footer />
    </>
  );
}

export default RegisterPage;